var _rect, _path, _path2, _rect2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamepadLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fillin: "current",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3335,
    y: 18.8365,
    width: 2.66667,
    height: 2.66667,
    rx: 1,
    fillin: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.8365H8",
    stroke: "current",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16.1698L10.6665 21.5031",
    stroke: "current",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3335,
    y: 16.1698,
    width: 2.66667,
    height: 2.66667,
    rx: 1,
    fillin: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 10.8365V10.8365C18.6668 9.78112 18.6668 9.25343 18.4507 8.82713C18.3336 8.59597 18.1726 8.38978 17.9767 8.22003C17.6156 7.90701 17.1036 7.77902 16.0798 7.52306L16.0002 7.50315C14.8993 7.22794 14.3489 7.09033 13.9717 6.73973C13.8162 6.59514 13.6847 6.42671 13.5822 6.24077C13.3335 5.78986 13.3335 5.22249 13.3335 4.08775V2.83649",
    stroke: "current",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.8365C4 15.4247 4 13.7189 4.82659 12.5437C5.03939 12.2412 5.28763 11.9704 5.56495 11.7382C6.64218 10.8365 8.2059 10.8365 11.3333 10.8365H20.6667C23.7941 10.8365 25.3578 10.8365 26.435 11.7382C26.7124 11.9704 26.9606 12.2412 27.1734 12.5437C28 13.7189 28 15.4247 28 18.8365C28 22.2482 28 23.9541 27.1734 25.1293C26.9606 25.4318 26.7124 25.7026 26.435 25.9348C25.3578 26.8365 23.7941 26.8365 20.6667 26.8365H11.3333C8.2059 26.8365 6.64218 26.8365 5.56495 25.9348C5.28763 25.7026 5.03939 25.4318 4.82659 25.1293C4 23.9541 4 22.2482 4 18.8365Z",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadLight);
export default __webpack_public_path__ + "static/media/Gamepad_light.d0fbe2483ac706d9c26436687b21f91e.svg";
export { ForwardRef as ReactComponent };